import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

const HeroSection = () => {
  return (
    <section className="pt-32 pb-20 px-6 bg-gradient-to-br from-amber-50 via-stone-50 to-orange-50">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center space-y-6">
          <div className="inline-block hero-tagline">
            <span className="text-blue-900 font-semibold tracking-wide uppercase text-sm">
              Authentic Italian Food Exports
            </span>
          </div>
          <h1 className="md:text-6xl lg:text-7xl !font-bold !text-5xl text-stone-900 hero-headline">
            Italian food export company{" "}
            <span className="block text-blue-900 mt-2">for importers and distributors</span>
          </h1>
          <p className="text-lg md:text-xl text-stone-500 max-w-4xl mx-auto italic">
            Exporting the best food &amp; beverages of Italy to the world
          </p>
          <p className="text-xl md:text-2xl text-stone-600 max-w-6xl mx-auto leading-relaxed hero-subtext">
            ALL-FOOD is your dedicated Italian food export company and sourcing partner based in Tuscany. 
            We help <span className="font-semibold text-blue-900">importers</span>, <span className="font-semibold text-blue-900">distributors</span>, and <span className="font-semibold text-blue-900">retailers</span> build and manage their Italian food and beverages product portfolio.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6 hero-button">
            <Button
              size="lg"
              onClick={() => window.open('https://calendar.app.google/LPFc1fEyd8AWrEJVA', '_blank')}
              className="bg-blue-900 hover:bg-blue-950 text-white px-8 py-6 text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              Schedule a Consultation
              <ChevronRight className="ml-2" size={20} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
